export default __webpack_public_path__ + "static/media/our-team-member-01.d43a6181.jpg";